// extracted by mini-css-extract-plugin
export default {"header":"header_header__b8U2K","logo":"header_logo__E49Uw","themeSwitcher":"header_themeSwitcher__AnFh-","themeText":"header_themeText__OumnV"};